<script setup lang="ts">
import { defineEmits } from "vue";
import { Trash2 } from "lucide-vue-next";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Loader2 } from 'lucide-vue-next'
import { cn } from "@/lib/utils";

defineProps<{ open: boolean, loading: boolean }>()
const emit = defineEmits(["confirm", "update:open"]);

const handleDelete = () => {
  emit("confirm");
};
</script>

<template>
  <Dialog :open="open" @update:open="(value) => $emit('update:open', value)">
    <DialogContent class="sm:max-w-lg">
      <DialogHeader>
        <DialogTitle class="flex gap-2 items-center text-2xl">
          <!-- <span class="p-2 rounded-full bg-red-100 dark:bg-red-900">
            <Trash2 class="h-6 w-6 text-red-600 dark:text-red-300" />
          </span> -->
          Confirmar Exclusão
        </DialogTitle>
        <DialogDescription class="text-base py-4">
          Você tem certeza que deseja deletar este item? Esta ação não pode ser revertida.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter class="sm:justify-start">
        <Button type="button" variant="secondary" @click="$emit('update:open', false)" class="w-full sm:w-auto">
          Cancelar
        </Button>
        <Button
          type="button"
          variant="destructive"
          :disabled="loading"
          @click="handleDelete"
          :class="cn(
            'w-full sm:w-auto',
            'bg-red-500 hover:from-red-600 hover:to-pink-600',
            'border-0 text-white font-semibold'
          )"
        >
          <Loader2 v-if="loading" class="w-4 h-4 animate-spin" />
          Deletar
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>
